<div class="fuse-card auto-width mb-12 mat-card mat-elevation-z2 p-0 m-l-10"
  [ngClass.gt-sm]="'mb-0 mr-0 p-0 m-r-0 m-b-6'">

  <div class="p-10 pt-10 full-height">
    <div *ngIf="isLoadingLeavePanel" class="m-auto leave-panel">
      <mat-progress-spinner class="m-auto" [diameter]="50" color="primary" mode="indeterminate">
      </mat-progress-spinner>
    </div>

    <div class="full-height" *ngIf="!isLoadingLeavePanel">
      <div class="leave-panel  right-details-wrap" *ngIf="isBlockedEmployee">
        <table class="border-none name-tbl">
          <caption></caption>
          <tr>
            <th></th>
          </tr>
          <tr>
            <td>
              <span class="f-w-600 m-r-5 fs-16 fc-r uppercase">TRABAJADOR BLOQUEADO</span>
            </td>
        </table>
      </div>

      <div class="leave-panel  right-details-wrap" *ngIf="!isBlockedEmployee && !this.isExistLeave">
        <table class="border-none name-tbl">
          <tr>
            <caption></caption>
          <tr>
            <th></th>
          </tr>
          <td>
            <span class="f-w-600 m-r-5 fs-16 uppercase">SIN BAJAS</span>
          </td>
        </table>
      </div>

      <div class="leave-panel right-details-wrap" *ngIf="!isBlockedEmployee && this.isExistLeave"
        [class.action-leave-panel]="sharedService.selectedSelectionTabId === 3">

        <table class="border-none name-tbl">
          <caption></caption>
          <tr>
            <th></th>
          </tr>
          <tr>
            <td>
              <span class="f-w-600 m-r-5 fs-16 fc-b uppercase">
                {{leaveGenericDataModel.apellidos}}
                {{(leaveGenericDataModel.apellidos && leaveGenericDataModel.nombre) ? ', ':''}}
                {{leaveGenericDataModel.nombre}}</span>
              <span class="f-w-600 fs-14 fc-r right-float"><span
                  class="m-r-5 uppercase">{{leaveGenericDataModel.puestoUrgente}}</span>
                <mat-icon class="s-18 mat-icon material-icons mat-icon-no-color" role="img" aria-hidden="true"
                  *ngIf='leaveGenericDataModel.absentista === "S"'>error
                </mat-icon>
              </span>
            </td>
          </tr>
          <tr>
            <td class="nevilRow">
              <ng-container *ngFor="let nivel of leaveGenericDataModel.nivelArray">
                <span class="fs-14 fc-b">{{nivel}}</span>
                <span>
                  <mat-icon class="fc-b s-16 mat-icon material-icons mat-icon-no-color" role="img" aria-hidden="true">
                    arrow_right</mat-icon>
                </span>
              </ng-container>
            </td>
          </tr>
          <tr>
            <td>
              <span class="fs-12">{{leaveGenericDataModel.sexo}}
                <span *ngIf="leaveGenericDataModel.age != null">de {{leaveGenericDataModel.age}} anos.</span>
                <span>{{leaveGenericDataModel.seniorityText}}</span>
              </span>
            </td>
          </tr>
          <tr>
            <td class="attrRow">
              <span class="fs-12 uppercase">{{leaveGenericDataModel.puesto}} -</span>
              <ng-container *ngFor="let attr of leaveGenericDataModel.attributeArray">
                <span class="fs-12"> {{attr}}</span><span class="fs-12"> -</span>
              </ng-container>
            </td>
          </tr>
          <tr *ngIf="leaveGenericDataModel.bradford != null && leaveGenericDataModel.bradford > 0">
            <td>
              <span class="fs-12"
                [ngClass]="{'fc-o':leaveGenericDataModel.bradford > 250 && leaveGenericDataModel.bradford <= 500, 'fc-r':leaveGenericDataModel.bradford > 500}">
                Indice Bradford: {{leaveGenericDataModel.bradford}}</span>
            </td>
          </tr>
        </table>

        <table class="border-none leave-tbl">
          <caption></caption>
          <tr>
            <th></th>
          </tr>
          <tr>
            <td>
              <span class="m-r-5 fs-14 fc-b m-l-5">{{leaveGenericDataModel.tipo}} -
                <span>{{leaveGenericDataModel.fbaja | date: 'dd/MM/yyyy'}}</span>
                <span *ngIf="leaveGenericDataModel.falta != null">..{{leaveGenericDataModel.falta | date: 'dd/MM/yyyy'}}
                </span>
                <span *ngIf="leaveGenericDataModel.falta == null && leaveGenericDataModel.fcierre != null"> - Cerrado el
                  {{leaveGenericDataModel.fcierre | date: 'dd/MM/yyyy'}} </span>
              </span>
              <span class="f-w-600 fs-14 fc-r right-float"><span
                  class="m-r-5 uppercase">{{leaveGenericDataModel.noVisitar}}</span>
              </span>
            </td>
          </tr>
          <tr>
            <td>
              <span class="fs-12 m-l-5">{{leaveGenericDataModel.leaveDaysArray[1]}}
                <span> , {{leaveGenericDataModel.reciadaDayArray[1]}}</span>
              </span>
            </td>
          </tr>

          <tr *ngIf="leaveGenericDataModel.avisoBaja != '' && leaveGenericDataModel.avisoBaja != null">
            <td>
              <span class="fs-12 m-l-5">Aviso:
                <span>{{leaveGenericDataModel.avisoBaja | date: 'dd/MM/yyyy'}}</span>
              </span>
            </td>
          </tr>

          <tr *ngIf="selectionService.permissionsList.includes('501')">
            <td>
              <span class="m-r-5 fs-12 m-l-5">{{leaveGenericDataModel.codDiagnostico}}
                <span> - {{leaveGenericDataModel.diagnostico}} </span>
                <span *ngIf="leaveGenericDataModel.estimatedDuration != null"> (T.E.:
                  {{leaveGenericDataModel.estimatedDuration}}
                  <span *ngIf="leaveGenericDataModel.estimatedDuration > 1"> dias)</span>
                  <span *ngIf="leaveGenericDataModel.estimatedDuration <= 1"> dia)</span>
                </span>
              </span>
              <span class="fs-12 right-float highlighted-span">
                <span *ngIf="leaveGenericDataModel.agudo != null && leaveGenericDataModel.agudo != ''"
                  class="m-r-5 uppercase">{{leaveGenericDataModel.agudo}}</span>
                <span *ngIf="leaveGenericDataModel.cronico != null && leaveGenericDataModel.cronico != ''"
                  class="m-r-5 uppercase">{{leaveGenericDataModel.cronico}}</span>
                <span *ngIf="leaveGenericDataModel.cirujia != null && leaveGenericDataModel.cirujia != ''"
                  class="m-r-5 uppercase">{{leaveGenericDataModel.cirujia}}</span>
                <span *ngIf="leaveGenericDataModel.embarazada != null && leaveGenericDataModel.embarazada != ''"
                  class="m-r-5 uppercase">{{leaveGenericDataModel.embarazada}}</span>
              </span>
            </td>
          </tr>

          <tr>
            <td>
              <span *ngIf="leaveGenericDataModel.fpa != null" class="m-r-5 fs-12 m-l-5">F.P.A.:
                <span>{{leaveGenericDataModel.fpa | date: 'dd/MM/yyyy'}}</span>
              </span>
              <span class="f-w-600 fs-12 fc-r right-float">
                <span class="uppercase">{{leaveGenericDataModel.justificada}}</span>
                <span class="m-r-5 uppercase"
                  *ngIf="leaveGenericDataModel.actitud != null && leaveGenericDataModel.actitud != ''">&nbsp;-&nbsp;{{leaveGenericDataModel.actitud}}</span>
              </span>
            </td>
          </tr>

          <tr *ngIf="selectionService.permissionsList.includes('516')">
            <td>
              <span class="fs-12 m-l-5">{{leaveGenericDataModel.riesgosPsicosociales}}
              </span>
            </td>
          </tr>

        </table>
        <table *ngIf="selectionService.permissionsList.includes('204')" class="border-none task-tbl">
          <caption></caption>
          <tr *ngFor="let item of leaveGenericDataModel.tareaModelList">
            <table>
              <caption></caption>
              <tr>
                <th></th>
              </tr>
              <tr>
                <td>
                  <span class="fs-12">Tarea:
                    <span>{{item.fecha | date: 'dd/MM/yyyy'}} </span>
                    <span class="uppercase"> - {{item.tarea1}}</span>
                    <span class="uppercase" *ngIf="selectionService.permissionsList.includes('510')"> -
                      {{item.autor}}
                    </span>
                  </span>
                </td>
              </tr>
              <tr *ngIf="item.comentario != null">
                <td>
                  <span class="fs-12">{{item.comentario}}</span>
                </td>
              </tr>
            </table>
          </tr>
        </table>

        <table class="border-none visita-tbl">
          <caption></caption>
          <tr *ngFor="let item of leaveGenericDataModel.actuacionModelList">
            <table
              [ngClass]="{'actuacion-hide':!selectionService.permissionsList.includes('509') && (item.tipo===29998 || item.tipo===29999)}">
              <caption></caption>
              <tr>
                <th></th>
              </tr>
              <tr>
                <td>
                  <span class="f-w-600">
                    {{item.fecha | date: 'dd/MM/yyyy'}} -
                    <span>{{item.tipoActuacion}}</span>
                    <span *ngIf="item.ausenciaJustificada !=null && item.ausenciaJustificada != ''">
                      {{item.ausenciaJustificada}}
                    </span>
                    <span class="f-w-600 right-float" *ngIf="selectionService.permissionsList.includes('510')"><span
                        class="m-r-5">{{item.autor}}</span>
                    </span>
                  </span>
                </td>
              </tr>
              
              <tr
                *ngIf="(selectionService.permissionsList.includes('501')) || (selectionService.permissionsList.includes('627') && item.tipo === 49999 )  || (selectionService.permissionsList.includes('523') && item.tipo === 44218 )">
                <td>
                  <span *ngIf="item.comentarios" class="border-none">
                    <span>{{ item.displayComment }}</span>
                    <span *ngIf="item.comentarios.length > 115 && item.displayComment !== item.comentarios"
                      aria-label="search" class="showmore-btn fa fa-ellipsis-h" (click)="clickSeeMore(item)"></span>
                  </span>
                </td>
              </tr>
              <tr *ngIf="selectionService.permissionsList.includes('513') && item.comentarioParaEmpresa !=null">
                <td *ngIf="item.tipo==49901">{{item.comentarioParaEmpresa}}</td>
                <td *ngIf="item.tipo!=49901">Comentario para la Empresa: {{item.comentarioParaEmpresa}}</td>
              </tr>
              <tr *ngIf="selectionService.permissionsList.includes('513') && item.comentarioParaMutua !=null">
                <td *ngIf="item.tipo==59901">{{item.comentarioParaMutua}}</td>
                <td *ngIf="item.tipo!=59901">Comentario para la Mutua: {{item.comentarioParaMutua}}</td>
              </tr>
            </table>
          </tr>
        </table>



      </div>
    </div>
  </div>
</div>